import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import { grayColor } from "../../assets/jss/material-dashboard-react";
import { isNumber } from "../../utils/isNumber";
import { showWarningToast } from "../../utils/toastMessages";
import { ToastContainer } from "react-toastify";

const styles = (theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: "0px",
    minHeight: "auto",
    fontSize: "12px",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "0px",
    textDecoration: "none",
    paddingBottom: "20px",
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "16px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0",
  },
  description: {
    marginTop: "2px",
    marginBottom: "0",
    textAlign: "justify",
  },
  rowReverseMd: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row-reverse",
    },
  },
});

const useStyles = makeStyles(styles);

export default function InputNumbersForm(props) {
  const classes = useStyles();
  const {
    alternativesNum,
    setAlternativesNum,
    criteriaNum,
    setCriteriaNum,
    onNext,
  } = props;

  const [alternativesError, setAlternativesError] = useState(
    !(alternativesNum > 0)
  );
  const [criteriaError, setCriteriaError] = useState(!(criteriaNum > 0));
  const [disabledButton, setDisabledButton] = useState(false);

  const handleAlternativesChange = (e) => {
    setAlternativesNum(e?.target?.value);

    if (isNumber(e?.target?.value) && e?.target?.value > 0)
      setAlternativesError(false);
    else if (e?.target?.value?.length > 0) setAlternativesError(true);
    else setAlternativesError(null);
  };

  const handleCriteriaChange = (e) => {
    setCriteriaNum(e?.target?.value);

    if (
      isNumber(e?.target?.value) &&
      e?.target?.value > 0 &&
      e?.target?.value <= 11
    )
      setCriteriaError(false);
    else if (e?.target?.value?.length > 0) setCriteriaError(true);
    else setCriteriaError(null);

    if (isNumber(e?.target?.value) && e?.target?.value > 11) {
      showWarningToast({
        title: "Neispravan unos!",
        message: "Maksimalan broj kriterijuma je 11!",
      });
    }
  };

  return (
    <div justify="center">
      <Card xs={12} sm={6} md={6}>
        <CardHeader color="success">
          <h4 className={classes.cardTitleWhite}>Unos podataka</h4>
          <p className={classes.cardCategoryWhite}>
            Broj alternativa i kriterijuma
          </p>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <CustomInput
                labelText="Broj alternativa"
                id="alternativesNo"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  value: alternativesNum,
                  onChange: handleAlternativesChange,
                }}
                error={alternativesError}
                success={alternativesError == false ? true : false}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <ToastContainer />
              <CustomInput
                labelText="Broj kriterijuma"
                id="criteriaNo"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  value: criteriaNum,
                  onChange: handleCriteriaChange,
                }}
                error={criteriaError}
                success={criteriaError == false ? true : false}
              />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button
            color="success"
            onPress={onNext}
            disabled={!(alternativesError == false && criteriaError == false)}
          >
            Sljedeće
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}

